<template>
    <ThLink
        v-if="route"
        :to="route"
    >
        <ItemRingBuilderStone :data="data" />
    </ThLink>

    <ItemRingBuilderStone
        v-else
        :data="data"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { assertNever } from '@/helpers'
import type { ButtonRouteRelative } from '@/components/ui/buttons/useThButton'
import type { RingBuilderStoneTypes } from '@/domain/product/ring/ring-builder'
import { useRoutes } from '@/router/routes'

import ItemRingBuilderStone from '@/components/rings/ring-builder/item/ItemRingBuilderStone.vue'
import ThLink from '@/components/ui/buttons/ThLink.vue'
import { GemsApi_StoneCategory } from '@/graphql/api'

const props = defineProps<{
    data: RingBuilderStoneTypes
}>()

const routes = useRoutes()

const route = computed((): ButtonRouteRelative | undefined => {
    switch (props.data.__typename) {
        case 'GemsApi_Stone':
            switch (props.data.categoryWithInfo.code) {
                case GemsApi_StoneCategory.Diamond:
                case GemsApi_StoneCategory.LabGrownDiamond:
                    return routes.diamondSearch(
                        props.data.categoryWithInfo.code,
                        props.data.shapeWithInfo.code,
                        undefined,
                        undefined,
                        props.data.identifier
                    )
                case GemsApi_StoneCategory.Gemstone:
                    return routes.gemstoneSearch(
                        undefined,
                        undefined,
                        props.data.shapeWithInfo.code,
                        undefined,
                        undefined,
                        props.data.identifier
                    )
                case GemsApi_StoneCategory.FancyDiamond:
                case GemsApi_StoneCategory.LabGrownFancyDiamond:
                    return routes.fancyDiamondSearch(
                        undefined,
                        props.data.shapeWithInfo.code,
                        undefined,
                        undefined,
                        props.data.identifier
                    )
                default:
                    return assertNever(props.data.categoryWithInfo.code, {})
            }
        case 'NonSkuLabGrown':
            return routes.nonSku.labGrownDiamondSearch(
                {
                    shape: props.data.shape.systemCode,
                },
                undefined,
                props.data.id
            )
        case 'NonSkuGemstone':
            return routes.nonSku.gemstoneSearch(
                {
                    shape: props.data.shape.systemCode,
                },
                undefined,
                props.data.id
            )
        default:
            return assertNever(props.data, {})
    }
})
</script>
